import * as types from "types";
import { makeChatStreamParser } from "services/cortevaChain/methods/parseChatStream";
import {
  ChatRecordJsonSchema,
  type ChatRecordJson,
} from "../types/ChatRecordJson";
import { postChatRecord } from "../methods/postChatRecord";

export function makeChatRecorder(getAccessToken: () => Promise<string>) {
  const requestStartTime = Date.now();
  let chatRecord: Partial<ChatRecordJson> = {
    request_id: crypto.randomUUID(),
    requested_at: new Date().toISOString(),
  };

  const addParams = (params: Partial<ChatRecordJson>) => {
    chatRecord = { ...chatRecord, ...params };
  };

  const sendAnalytics = async (xhr: XMLHttpRequest) => {
    chatRecord.request_duration = Date.now() - requestStartTime;
    chatRecord.status_code = xhr.status;
    chatRecord.status_text = xhr.statusText;
    chatRecord.response_length = xhr.responseText.length;
    // If no error_message was added and the request failed, add a default
    // error message.
    if (
      chatRecord.error_message === undefined ||
      chatRecord.error_message === null
    ) {
      chatRecord.error_message =
        xhr.status === 200 ? null : `Request failed with status ${xhr.status}`;
    }
    // Try to get the last assistant message.
    try {
      // We only care about the streamed messages, older messages are
      // irrelevant so we initialize with an empty array.
      const parseChatStream = makeChatStreamParser([]);
      const streamedMessages = parseChatStream(xhr.responseText);
      const lastAssistantMessage = streamedMessages.findLast((msg) =>
        types.isAssistantResponseMessage(msg)
      );
      if (lastAssistantMessage !== undefined) {
        chatRecord.last_response_message_id = lastAssistantMessage.uuid;
        chatRecord.last_response_message = lastAssistantMessage.content;

        const tokenUsage = lastAssistantMessage.tokenUsage;
        if (tokenUsage !== undefined) {
          chatRecord.token_usage = tokenUsage;
        }

        const errorMessage = lastAssistantMessage.errorMessage;
        if (errorMessage !== undefined && errorMessage !== null) {
          chatRecord.error_message = errorMessage;
        }
      }
      // Add streamed messages to `messages`
      if (chatRecord.messages !== null && chatRecord.messages !== undefined) {
        let allMessages = JSON.parse(chatRecord.messages);
        allMessages = [...allMessages, ...streamedMessages];
        chatRecord.messages = JSON.stringify(allMessages);
      }
    } catch (error) {
      // pass
    }

    const validatedChatRecord = ChatRecordJsonSchema.safeParse(chatRecord);
    if (!validatedChatRecord.success) {
      console.error(
        "Failed to record chat completion metrics: validation failed",
        validatedChatRecord.error.issues
      );
      return;
    }

    postChatRecord(validatedChatRecord.data, getAccessToken).catch((err) => {
      console.error("Failed to record chat completion metrics:", err);
    });
  };

  return { addParams, sendAnalytics };
}
